import {MoovementApiClient} from "src/app/infrastructure/moovement-api/web-api/moovement.api-client";
import {Injectable} from "@angular/core";
import {map, Observable} from "rxjs";
import {Farm, FarmReference} from "src/app/infrastructure/moovement-api/models/farm";
import {
  Animal,
  Device,
  FixedSamplePoint,
  LoRaGateway,
  Paddock,
  PaddockGeometry,
  WaterPoint
} from "src/app/infrastructure/moovement-api/models/asset";
import {enrichAnimal} from "src/app/infrastructure/moovement-api/web-api/animal.api-client";

@Injectable({
  providedIn: 'root'
})
export class FarmApiClient extends MoovementApiClient {



  getFarmReferences(): Observable<Array<FarmReference>> {
    return this.httpClient.get<Array<FarmReference>>(`${this.baseUrl}/api/farm/refs`);
  }

  getFarm(farmId: string): Observable<Farm> {
    return this.httpClient.get<Farm>(`${this.baseUrl}/api/farm/${farmId}`);
  }

  updateFarm(farm: Farm): Observable<Farm> {
    return this.httpClient.post<Farm>(`${this.baseUrl}/api/farm`, farm);
  }

  getAnimals(farmId: string): Observable<Animal[]> {
    return this.httpClient.get<Animal[]>(`${this.baseUrl}/api/farm/${farmId}/animals`).pipe(
      map(animals => animals.map(enrichAnimal))
    );
  }

  getWaterPoints(farmId: string): Observable<WaterPoint[]> {
    return this.httpClient.get<WaterPoint[]>(`${this.baseUrl}/api/farm/${farmId}/waterSources`);
  }

  getFixedSamplePoints(farmId: string): Observable<FixedSamplePoint[]> {
    return this.httpClient.get<FixedSamplePoint[]>(`${this.baseUrl}/api/farm/${farmId}/fixedSamplePoints`);
  }

  getDevices(farmId: string): Observable<Device[]> {
    return this.httpClient.get<Device[]>(`${this.baseUrl}/api/farm/${farmId}/devices`)
  }

  getPaddocks(farmId: string): Observable<Paddock[]> {
    return this.httpClient.get<Paddock[]>(`${this.baseUrl}/api/farm/${farmId}/paddocks`);
  }

  getPaddockGeometries(farmId: string): Observable<PaddockGeometry[]> {
    return this.httpClient.get<PaddockGeometry[]>(`${this.baseUrl}/api/farm/${farmId}/paddocks/geometry`);
  }

  getGateways(farmId: string): Observable<LoRaGateway[]> {
    return this.httpClient.get<LoRaGateway[]>(`${this.baseUrl}/api/farm/${farmId}/gateways`);
  }

  mergeFixedSamplePoint(farmId: string, fixedAsset: FixedSamplePoint): Observable<FixedSamplePoint> {
    return this.httpClient.put<FixedSamplePoint>(`${this.baseUrl}/api/farm/${farmId}/fixedSamplePoint`, fixedAsset);
  }

  addAnimal(farmId: string, newAnimal: Animal) {
    return this.httpClient.put<Animal>(`${this.baseUrl}/api/farm/${farmId}/animal`, newAnimal);
  }

  addPaddocks(farmId: string, file: File): Observable<Paddock[]> {
    return this.httpClient.post<Paddock[]>(`${this.baseUrl}/api/farm/${farmId}/paddocks`, file);
  }
}
